<template>
  <div id="CookieConsentDialog" :class="enableCookie ? 'active' : ''">
    <div class="dialog_body">
      <p>
        我們使用 Cookie
        來確保您在網站上能獲得良好的體驗。如果您繼續使用本網站，我們將認定您接受並理解我們的
        <router-link to="/terms/site_privacy">隱私政策</router-link>
        和
        <router-link to="/terms/terms_of_customer">使用者條款</router-link>
        。
      </p>

      <div class="button_box">
        <button @click="AspectConsent" class="px-10 py-3 main_button md:px-14">
          接受
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GTM_UpdateConsent } from "@/tools/googleTagManager.js";
export default {
  name: "CookieConsentDialog",
  data() {
    return {
      enableCookie: false,
    };
  },
  methods: {
    AspectConsent() {
      this.enableCookie = true;
      GTM_UpdateConsent(true);
    },
  },
};
</script>
